import { CreateSingleton } from "@pdfking/tfunc"
import has_dom from "@pdfking/workflow/utils/has_dom"

export default CreateSingleton(
  (): boolean =>
    has_dom() && !(navigator.maxTouchPoints > 0 || "ontouchstart" in window)
)
